/**
 * Inkwell Jr. Logo Assets
 *
 * Logos are stored in /public for direct web access.
 * This module provides typed paths for React component usage.
 *
 * Usage:
 *   import { LogoSvg, LogoPng } from '@/assets/brand/logos';
 *   <img src={LogoSvg} alt="Inkwell Jr." />
 */

// Primary logo - SVG (preferred for web)
export const LogoSvg = '/Inkwell Jr.svg';

// Raster versions
export const LogoPng = '/Inkwell Jr.png';
export const LogoJpg = '/Inkwell Jr.jpg';

// Default export for convenience
export default LogoSvg;

// Logo configuration for different contexts
export const logoConfig = {
  // Primary logo for headers, navigation
  primary: {
    src: LogoSvg,
    alt: 'Inkwell Jr.',
    defaultHeight: 48,
  },

  // Smaller logo for compact spaces
  compact: {
    src: LogoSvg,
    alt: 'Inkwell Jr.',
    defaultHeight: 32,
  },

  // Large logo for hero sections, splash screens
  hero: {
    src: LogoPng, // Use PNG for large sizes for quality
    alt: 'Inkwell Jr.',
    defaultHeight: 120,
  },
} as const;
